import { inputAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { focusBorder } from "../../../../theme/foundations/static";
import { InputVariant } from "../Input.types";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    field: {
        _disabled: {
            backgroundColor: "semantic.background.disabled",
            opacity: 1,
            color: "semantic.text.disabled",
            borderColor: "transparent",
            _placeholder: {
                color: "semantic.text.disabled",
            },
        },
        _hover: {
            _disabled: {
                backgroundColor: "semantic.background.disabled",
                color: "semantic.text.disabled",
                borderColor: "transparent",
                _placeholder: {
                    color: "semantic.text.disabled",
                },
            },
        },
    },
});
const variantFilled = definePartsStyle(() => ({
    field: {
        background: "semantic.surface.1",
        border: "1px solid",
        borderColor: "semantic.border.primary",
        _placeholder: {
            color: "semantic.text.tertiary",
        },
        _hover: {
            background: "semantic.cta.secondaryHover",
            border: "1px solid",
            borderColor: "semantic.interactive.primary",
            _placeholder: {
                color: "semantic.interactive.primary",
            },
        },
        _focus: Object.assign(Object.assign({}, focusBorder), { _placeholder: {
                color: "semantic.interactive.primary",
            } }),
        _active: {
            border: "1px solid",
            borderColor: "semantic.outline.link",
            _placeholder: {
                color: "semantic.interactive.primary",
            },
        },
    },
}));
const variantError = definePartsStyle(() => ({
    field: {
        background: "semantic.background.error",
        border: "1px solid",
        borderColor: "semantic.border.error",
        _focus: Object.assign(Object.assign({}, focusBorder), { background: "semantic.surface.1" }),
        _active: {
            border: "1px solid",
            borderColor: "semantic.outline.link",
        },
    },
}));
const variantSuccess = definePartsStyle(() => ({
    field: {
        background: "semantic.surface.1",
        border: "1px solid",
        borderColor: "semantic.border.primary",
        _hover: {
            background: "semantic.surface.1",
            border: "1px solid",
            borderColor: "semantic.text.link",
        },
        _focus: focusBorder,
        _active: {
            border: "1px solid",
            borderColor: "semantic.outline.link",
        },
    },
}));
const variants = {
    [InputVariant.FILLED]: variantFilled,
    [InputVariant.ERROR]: variantError,
    [InputVariant.SUCCESS]: variantSuccess,
};
const sizes = {
    lg: definePartsStyle({
        field: {
            height: "12",
            fontSize: "5",
            lineHeight: "core.10",
            fontWeight: "core.demiBold",
            py: "3",
            color: "semantic.text.primary",
            borderRadius: "none",
            _placeholder: {
                color: "semantic.text.quaternary",
            },
        },
    }),
};
const inputTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
    defaultProps: {
        size: "lg",
        variant: InputVariant.FILLED,
    },
});
export default inputTheme;
//# sourceMappingURL=Input.default.js.map